<template>
  <div id="sso" class="page white">
    <el-container class="content-aside">
      <el-main class="cpl-main">
        <!-- Content -->
        <el-row :gutter="0" class="main-content-row hide-scrollbar">
          <div class="content-wrapper">
          </div>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script src="./sso.js"></script>
<style lang="scss" src="./sso.scss"></style>
